import React from "react";
import PropTypes from "prop-types";

// Poistka pre samotne stiahnutie mobilnej casti.
//
// Mobilna aplikacia sa stahuje az ked na nu niekto pride. Ked v tej chvili
// vypadne signal, stiahnutie zlyha, React to vyhodi ako chybu pri vykreslovani
// a clovek vidi bielu obrazovku, z ktorej sa neda urobit vobec nic.
// HraniceChyby su vnutri mobilnej casti, takze tento pripad zachytit nemozu,
// ta cast este neexistuje. Preto este jedna poistka nad tym.
class Nacitanie extends React.Component {
  constructor(props) {
    super(props);
    this.state = { zlyhalo: false };
  }

  static getDerivedStateFromError() {
    return { zlyhalo: true };
  }

  componentDidCatch(chyba) {
    console.error("[MOBIL] nepodarilo sa stiahnut aplikaciu:", chyba);
  }

  render() {
    if (!this.state.zlyhalo) {
      return this.props.children;
    }
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "14px",
          padding: "24px",
          textAlign: "center",
          background: "#F5F5F5",
          color: "#111111",
          fontSize: "16px",
          lineHeight: 1.5,
        }}
      >
        <strong style={{ fontSize: "19px" }}>Aplikácia sa nenačítala</strong>
        <span style={{ color: "#666666", maxWidth: "320px" }}>
          Zvyčajne je to slabý signál. Skúste to znova, keď budete mať
          pripojenie.
        </span>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            height: "48px",
            padding: "0 24px",
            border: "none",
            borderRadius: "6px",
            background: "#D9001B",
            color: "#fff",
            fontWeight: 600,
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Skúsiť znova
        </button>
      </div>
    );
  }
}

Nacitanie.propTypes = { children: PropTypes.node };

export default Nacitanie;
